var map = {
	"./A_Ghost_Town.mp3": 480,
	"./Beach_Disco.mp3": 481,
	"./Central_Park.mp3": 482,
	"./Down_with_Paradise.mp3": 483,
	"./Ice_Cream.mp3": 484,
	"./If_I_Had_a_Chicken.mp3": 485,
	"./Jazz_Mango.mp3": 486,
	"./Joy_to_the_World.mp3": 487,
	"./November.mp3": 488,
	"./Russian_Dance.mp3": 489,
	"./Slowly_Until_We_Get_There.mp3": 490,
	"./Splashing_Around.mp3": 491,
	"./Spy_Suite.mp3": 492,
	"./The_Plan_s_Working.mp3": 493,
	"./Waterfall.mp3": 494
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 479;